import type { BlackoutDateField } from './types';

export const BLACKOUT_DATE_FIELDS: Array<BlackoutDateField> = [];
